import { useTranslation } from "react-i18next";
export const MONTHS_TR = () => {
  const { t } = useTranslation();
  return {
    JANUARY: t("common.MONTHS.JANUARY"),
    FEBRUARY: t("common.MONTHS.FEBRUARY"),
    MARCH: t("common.MONTHS.MARCH"),
    APRIL: t("common.MONTHS.APRIL"),
    MAY: t("common.MONTHS.MAY"),
    JUNE: t("common.MONTHS.JUNE"),
    JULY: t("common.MONTHS.JULY"),
    AUGUST: t("common.MONTHS.AUGUST"),
    SEPTEMBER: t("common.MONTHS.SEPTEMBER"),
    OCTOBER: t("common.MONTHS.OCTOBER"),
    NOVEMBER: t("common.MONTHS.NOVEMBER"),
    DECEMBER: t("common.MONTHS.DECEMBER"),
  };
};

export const SORT_OPTIONS = {
  ASC: "asc", // dont translate this
  DESC: "desc", // dont translate this
};

export const SORTING_OPTIONS_DATENAME = {
  STARTDATE: "startDate",
  ENDDATE: "endDate",
};
export const THEME_COLORS = {
  LIGHT: "light", // dont translate this
  DARK: "dark", // dont translate this
  DEFAULT: "default",
};

export const THEME_SWITCH = {
  LIGHT_MODE: "Light mode",
  DARK_MODE: "Dark mode",
};

export const COMMON_CONST_ENUM = () => {
  const { t } = useTranslation();
  return {
    FORMIK_ERROR_MESSAGE_COMMON: t(
      "common.commonEnum.formikErrorMessageCommon",
    ),
    PLEASE_ENTER_EMAIL: t("common.commonEnum.pleaseEnterEmail"),
    PLEASE_ENTER_PASSWORD: t("common.commonEnum.pleaseEnterPassword"),
    PLEASE_ENTER_CONFIRMPASSWORD: t(
      "common.commonEnum.pleaseEnterConfirmPassword",
    ),
    PLEASE_ENTER_EMPLOYEEID: t("common.commonEnum.pleaseEnterEmployeeId"),
    PLEASE_ENTER_FIRSTNAME: t("common.commonEnum.pleaseEnterFirstName"),
    PLEASE_ENTER_LASTNAME: t("common.commonEnum.pleaseEnterLastName"),
    PLEASE_SELECT_POLICY: t("common.commonEnum.pleaseSelectPolicy"),
    PLEASE_FILL_HOLIDAY_NAME: t("common.commonEnum.pleaseFillHolidayName"),
    PLEASE_SELECT_ASSIGNEES: t("common.commonEnum.pleaseSelectAssignees"),
    PLEASE_FILL_POLICY_NAME: t("common.commonEnum.pleaseFillPolicyName"),
    PLEASE_ENTER_TIME_UNIT_VALUE: t(
      "common.commonEnum.pleaseEnterTimeUnitValue",
    ),
    PLEASE_ENTER_WORKSPACE_NAME: t(
      "common.commonEnum.pleaseEnterWorkspaceName",
    ),
    PLEASE_ENTER_CUSTOM_FIELD_NAME: t(
      "common.commonEnum.pleaseEnterCustomFieldName",
    ),
    PLEASE_ENTER_GROUP_NAME: t("common.commonEnum.pleaseEnterGroupName"),
    INVALID_EMAIL: t("common.commonEnum.invalidEmail"),
    INVALID_TO_EMAIL: t("common.commonEnum.invalidToEmail"),
    INVALID_FROM_EMAIL: t("common.commonEnum.invalidFromEmail"),
    INVALID_CC_EMAIL: t("common.commonEnum.invalidCCEmail"),
    INVALID_BCC_EMAIL: t("common.commonEnum.invalidBCCEmail"),
    NO_DATA_FOUND_COMMON: t("common.commonEnum.noDataFoundCommon"),
    ACCESS_DENIED: t("common.commonEnum.accessDenied"),
    YOU_DONOT_HAVE_PERMISSION: t("common.commonEnum.youDontHavePermission"),
    YOU_DONOT_HAVE_ACCESS: t("common.commonEnum.youDontHaveAccess"),
    REDIRECT_UPDATED_MODULE: t("common.commonEnum.redirectUpdatedModule"),
    SECOND_REDIRECTING: t("common.commonEnum.secondRedirecting"),
    PLEASE_FILL_THE_VALIDEMAIL: t("common.commonEnum.pleaseFillTheValidEmail"),
    CLEAR_FILTER: t("common.commonEnum.clearFilter"),
    EXPORT_OPTION: t("common.commonEnum.exportOption"),
    PDF_OPTION: t("common.commonEnum.pdfOption"),
    EXCEL_OPTION: t("common.commonEnum.excelOption"),
    CSV_OPTION: t("common.commonEnum.csvOption"),
    OPERATION_SUCCESSFUL: t("common.commonEnum.operationalSuccess"),
    COMMON_LOADING_TEXT: t("common.commonEnum.loading"),
    COMMON_EMPLOYEE_ID_PLACEHOLDER: t("common.commonEnum.employeeId_PH"),
    COMMON_EMPLOYEE_ID: t("common.commonEnum.employeeId"),
    COMMON_FIRST_NAME: t("common.commonEnum.firstName"),
    COMMON_FIRST_NAME_PLACEHOLDER: t("common.commonEnum.firstName_PH"),
    COMMON_LAST_NAME: t("common.commonEnum.lastName"),
    COMMON_LAST_NAME_PLACEHOLDER: t("common.commonEnum.lastName_PH"),
    COMMON_PASSWORD_PLACEHOLDER: t("common.commonEnum.commonpassword"),
    COMMON_CONPASSWORD_PLACEHOLDER: t(
      "common.commonEnum.commonConfirmPassword",
    ),
    COMMON_ORSINGUP: t("common.commonEnum.commonOrsingUp"),
    COMMON_SINGUPGOALS: t("common.commonEnum.commonSingupGoals"),
    COMMON_SINGUP_UNTIL: t("common.commonEnum.commonSingupUntil"),
    CONTRACTOR_COMMON_STRING: t("common.commonEnum.contractor"),
    COMMON_ALL_MEMBERS: t("common.commonEnum.allMember"),
    COMMON_PAGINATION_ENTRIES: t("common.commonEnum.entries"),
    UPLOAD_LIMIT_WARNING_MESSAGE: t("common.commonEnum.uploadLimitWarning"),
    UPLOAD_RESTRICTION_MESSAGE: t("common.commonEnum.uploadRestriction"),
    START_TYPING: t("common.commonEnum.startTyping"),
    NOT_FOUND_404: t("common.commonEnum.notFound404"),
    HOME_PAGE_TEXT: t("common.commonEnum.homePageText"),
    SHOW_LESS: t("common.commonEnum.showLess"),
    SHOW_MORE: t("common.commonEnum.showMore"),
    COMMON_EMAIL: t("common.commonEnum.email"),
    COMMON_PASSWORD: t("common.commonEnum.password"),
    ERROR_OCCURED: t("common.commonEnum.errorOccured"),
    CHARACTERS_REMAINING: t("common.commonEnum.charactersRemaining"),
    SPECIAL_CHARACTER_NOT_ALLOWED: t(
      "common.commonEnum.specialCharactersNotAllowed",
    ),
    UPLOAD_IMAGE_SIZE_LESS_1MB: t("common.commonEnum.uploadLess1mbImages"),
    CHOOSE_VALID_CURRENCY: t("common.commonEnum.choosevalidcurrency"),
    CHOOSE_MODULE: t("common.commonEnum.pleaseChooseModule"),
    CHOOSE_TYPE: t("common.commonEnum.pleaseChooseType"),
    FILL_OPTION_VALUE: t("common.commonEnum.pleaseFillOptionValue"),
    TEMPLATE_NAME_REQUIRED: t("common.commonEnum.templateNameRequired"),
    TASK_NAME_REQUIRED: t("common.commonEnum.taskNameRequired"),
    UNABLE_DELETE_ACTION: t(
      "common.commonEnum.unableDeleteAction_AtLeastOneActionAssigned",
    ),
    FILL_TASK_TEMPLATE_NAME: t("common.commonEnum.pleaseFillTaskTemplateName"),
    FILL_TASK_NAME: t("common.commonEnum.pleaseFillTaskName"),
    FILL_SESSION_NAME: t("common.commonEnum.pleaseFillSessionName"),
    FILL_START_DATE: t("common.commonEnum.pleaseFillstartdate"),
    FILL_END_DATE: t("common.commonEnum.pleaseFillenddate"),
    SELECT_SESSION: t("common.commonEnum.pleaseSelectSession"),
    SELECT_OWNERS: t("common.commonEnum.pleaseSelectOwners"),
    SELECT_SESSION_OWNERS_OBJECTIVE: t(
      "common.commonEnum.pleaseSelectSessionOwnersObjective",
    ),
    ENTER_TODO_ITEM: t("common.commonEnum.PleaseEnterTodoItem"),
    EMPTY_TODO_CANNOT_SAVED: t("common.commonEnum.emptyTodoItemsCannotSaved"),
    NO_TODO_ITEMS_FOUND: t("common.commonEnum.NO_TODO_ITEMS_FOUND"),
    FILL_TITLE: t("common.commonEnum.FILL_TITLE"),
    SELECT_UNIT: t("common.commonEnum.SELECT_UNIT"),
    SELECT_KEY_RESULTS_TYPE: t("common.commonEnum.SELECT_KEY_RESULTS_TYPE"),
    FILL_DESC: t("common.commonEnum.FILL_DESC"),
    SELECT_FOLLOW_UPS_METHOD: t("common.commonEnum.SELECT_FOLLOW_UPS_METHOD"),
    SELECT_DATE_RANGE: t("common.commonEnum.SELECT_DATE_RANGE"),
    FILL_TARGET_VALUE: t("common.commonEnum.FILL_TARGET_VALUE"),
    TARGET_INITIAL_VALUES_CANNOT_SAME: t(
      "common.commonEnum.TARGET_INITIAL_VALUES_CANNOT_SAME",
    ),
    FILL_INITIAL_VALUE: t("common.commonEnum.FILL_INITIAL_VALUE"),
    PLEASE_SELECT_OBJECTIVE: t("common.commonEnum.PLEASE_SELECT_OBJECTIVE"),
    PL_SL_PROJECT: t("common.commonEnum.PL_SL_PROJECT"),
    PL_SL_TASK: t("common.commonEnum.PL_SL_TASK"),
    PL_SL_DAYS: t("common.commonEnum.PL_SL_DAYS"),
    PL_SL_FREQUESNCY: t("common.commonEnum.PL_SL_FREQUESNCY"),
    FILL_DATE: t("common.commonEnum.FILL_DATE"),
    PL_SL_WEEK_POSITION: t("common.commonEnum.PL_SL_WEEK_POSITION"),
    PL_SL_DAY: t("common.commonEnum.PL_SL_DAY"),
    PL_SL_TIMEZONE: t("common.commonEnum.PL_SL_TIMEZONE"),
    PL_SL_PARTICIPANTS: t("common.commonEnum.PL_SL_PARTICIPANTS"),
    PL_SL_START_TIME: t("common.commonEnum.PL_SL_START_TIME"),
    PL_SL_END_TIME: t("common.commonEnum.PL_SL_END_TIME"),
    START_END_TIME_MUST_30M: t("common.commonEnum.START_END_TIME_MUST_30M"),
    VALID_EMAIL_ID: t("common.commonEnum.VALID_EMAIL_ID"),
    ITEMS_PER_PAGE: t("common.commonEnum.itemsPerPageText"),
    PL_ENTER_NEGATIVE_VALUE: t("common.commonEnum.PL_ENTER_NEGATIVE_VALUE"),
    VALUE_MUST_START_WIDTH_NUMBER: t(
      "common.commonEnum.VALUE_MUST_START_WIDTH_NUMBER",
    ),
    CURRENT_VALUE_REQUIRED: t("common.commonEnum.CURRENT_VALUE_REQUIRED"),
    FILE_UPLOAD_SUCCESSFULLY: t("common.commonEnum.FILE_UPLOAD_SUCCESSFULLY"),
    PL_UPLOAD_VALID_XLSX_FILE: t("common.commonEnum.PL_UPLOAD_VALID_XLSX_FILE"),
    PL_SL_SESSION: t("common.commonEnum.PL_SL_SESSION"),
    PL_SL_PRIVACY: t("common.commonEnum.PL_SL_PRIVACY"),
    PL_SL_STATUS: t("common.commonEnum.PL_SL_STATUS"),
    YOU_HAVE_UNUSED_COMMENT_CHECK_BR_SUBMIT: t(
      "common.commonEnum.YOU_HAVE_UNUSED_COMMENT_CHECK_BR_SUBMIT",
    ),
    CREATED_BY: t("common.commonEnum.CREATED_BY"),
    MODIFIED_BY: t("common.commonEnum.MODIFIED_BY"),
    LAST_MODIFIED_ON: t("common.commonEnum.LAST_MODIFIED_ON"),
    Pl_FILL_TAG_NAME: t("common.commonEnum.Pl_FILL_TAG_NAME"),
    FAILED_FETCH_ICS_FILE: t("common.commonEnum.FAILED_FETCH_ICS_FILE"),
    KINDLY_FILL_COMMENTS: t("common.commonEnum.KINDLY_FILL_COMMENTS"),
    NO_RECORDS_DISPLAY: t("common.commonEnum.NO_RECORDS_DISPLAY"),
    PL_FILL_PROJECT_NAME: t("common.commonEnum.PL_FILL_PROJECT_NAME"),
    PL_SL_CUSTOMER: t("common.commonEnum.PL_SL_CUSTOMER"),
    PL_SL_DEPARTMENT: t("common.commonEnum.PL_SL_DEPARTMENT"),
    PL_SL_BILLABLE: t("common.commonEnum.PL_SL_BILLABLE"),
    PL_SL_MANAGER: t("common.commonEnum.PL_SL_MANAGER"),
    SELECT_SESSIONS: t("common.commonEnum.SELECT_SESSIONS"),
    SELECT_OWNERSCH: t("common.commonEnum.SELECT_OWNERSCH"),
    SELECT_OBJECTIVES: t("common.commonEnum.SELECT_OBJECTIVES"),
    SELECT_KEYRESULTS: t("common.commonEnum.SELECT_KEYRESULTS"),
    PL_SELECT_SESSION_OWNERS: t("common.commonEnum.PL_SELECT_SESSION_OWNERS"),
    SESSION_NAME: t("common.commonEnum.SESSION_NAME"),
    OWNER_NAME: t("common.commonEnum.OWNER_NAME"),
    OBJECTIVE_NAME: t("common.commonEnum.OBJECTIVE_NAME"),
    KEYRESULT_NAME: t("common.commonEnum.KEYRESULT_NAME"),
    CHATFOR_GOAL: t("common.commonEnum.CHATFOR_GOAL"),
    START_STRATEGY_BUILDING: t("common.commonEnum.START_STRATEGY_BUILDING"),
    SHARE_YOUR_VISION: t("common.commonEnum.SHARE_YOUR_VISION"),
    TRANSFORM_YOUR_VISION_STRATEGIC_PLANNING: t(
      "common.commonEnum.TRANSFORM_YOUR_VISION_STRATEGIC_PLANNING",
    ),
    ASK_ANOTHER_QUESTION: t("common.commonEnum.ASK_ANOTHER_QUESTION"),
    CHAT_CLEAR: t("common.commonEnum.CHAT_CLEAR"),
    CHATMAIN_DES: t("common.commonEnum.CHATMAIN_DES"),
    THEME_TEXT: t("common.commonEnum.THEME_TEXT"),
    LANGUAGE_TEXT: t("common.commonEnum.LANGUAGE_TEXT"),
    HELLO_STRING: t("common.commonEnum.HELLO_STRING"),
    AND_STRING: t("common.commonEnum.AND_STRING"),
    CHAT_WELCOME_STRING: t("common.commonEnum.CHAT_WELCOME_STRING"),
    SELECTED_SESSION_BOT: t("common.commonEnum.SELECTED_SESSION_BOT"),
    SELECTED_OWNER_BOT: t("common.commonEnum.SELECTED_OWNER_BOT"),
    SELECTED_OBJECTIVE_BOT: t("common.commonEnum.SELECTED_OBJECTIVE_BOT"),
    SELECTED_KR_BOT: t("common.commonEnum.SELECTED_KR_BOT"),
    THINKING_TEXT_BOT: t("common.commonEnum.THINKING_TEXT_BOT"),
    ADD_AS_LABEL: t("common.commonEnum.ADD_AS_LABEL"),
    OKR_ERROR_JSON: t("common.commonEnum.OKR_ERROR_JSON"),
    KR_CREATE_SUCCESSS_PREFIX: t("common.commonEnum.KR_CREATE_SUCCESSS_PREFIX"),
    KR_CREATE_SUCCESSS_SUFFIX: t("common.commonEnum.KR_CREATE_SUCCESSS_SUFFIX"),
    KR_CREATE_FAIL: t("common.commonEnum.KR_CREATE_FAIL"),
    COMMENT_ADDED_BOT: t("common.commonEnum.COMMENT_ADDED_BOT"),
    COMMENT_BOT_FAIL: t("common.commonEnum.COMMENT_BOT_FAIL"),
    COMMENT_BOT_ERROR: t("common.commonEnum.COMMENT_BOT_ERROR"),
    BOT_OKR_CREATE_ERROR: t("common.commonEnum.BOT_OKR_CREATE_ERROR"),
    BOT_KR_CREATE_ERROR: t("common.commonEnum.BOT_KR_CREATE_ERROR"),
    PARSE_OKR_FAIL: t("common.commonEnum.PARSE_OKR_FAIL"),
    GOALS_KR_SUCCESS: t("common.commonEnum.GOALS_KR_SUCCESS"),
    GOALS_KR_FAIL: t("common.commonEnum.GOALS_KR_FAIL"),
    GOALS_SUCCESS_KR_FAILED: t("common.commonEnum.GOALS_SUCCESS_KR_FAILED"),
    BOT_ACTIONS: t("common.commonEnum.BOT_ACTIONS"),
    BOT_ADD_COMMENT: t("common.commonEnum.BOT_ADD_COMMENT"),
    BOT_CREATE_GOAL: t("common.commonEnum.BOT_CREATE_GOAL"),
    BOT_CREATE_KR: t("common.commonEnum.BOT_CREATE_KR"),
    BOT_CREATE_TASK: t("common.commonEnum.BOT_CREATE_TASK"),
    BOT_KR_SUCCESS: t("common.commonEnum.BOT_KR_SUCCESS"),
    BOT_KR_FAIL: t("common.commonEnum.BOT_KR_FAIL"),

    MAIN_DASHBOARD_TASK: t("common.commonEnum.MAIN_DASHBOARD_TASK"),
    MAIN_DASHBOARD_PENDING: t("common.commonEnum.MAIN_DASHBOARD_PENDING"),
    MAIN_DASHBOARD_EVENT: t("common.commonEnum.MAIN_DASHBOARD_EVENT"),
    MAIN_DASHBOARD_MEETINGS: t("common.commonEnum.MAIN_DASHBOARD_MEETINGS"),
    MAIN_DASHBOARD_ACTIVE: t("common.commonEnum.MAIN_DASHBOARD_ACTIVE"),
    MAIN_DASHBOARD_OKRS: t("common.commonEnum.MAIN_DASHBOARD_OKRS"),
    MAIN_DASHBOARD_APPROVALS: t("common.commonEnum.MAIN_DASHBOARD_APPROVALS"),
    MAIN_DASHBOARD_UPCOMINGS: t("common.commonEnum.MAIN_DASHBOARD_UPCOMINGS"),
    MAIN_DASHBOARD_COMPLETED: t("common.commonEnum.MAIN_DASHBOARD_COMPLETED"),
    MAIN_DASHBOARD_TSAS: t("common.commonEnum.MAIN_DASHBOARD_TSAS"),
    MAIN_DASHBOARD_ESAS: t("common.commonEnum.MAIN_DASHBOARD_ESAS"),
    MAIN_DASHBOARD_TOAS: t("common.commonEnum.MAIN_DASHBOARD_TOAS"),
    MAIN_DASHBOARD_OAKR: t("common.commonEnum.MAIN_DASHBOARD_OAKR"),
    MAIN_DASHBOARD_JOIN: t("common.commonEnum.MAIN_DASHBOARD_JOIN"),
    MAIN_DASHBOARD_DAILY: t("common.commonEnum.MAIN_DASHBOARD_DAILY"),
    MAIN_DASHBOARD_PROJECT: t("common.commonEnum.MAIN_DASHBOARD_PROJECT"),
    MAIN_DASHBOARD_PROJECTHUD: t("common.commonEnum.MAIN_DASHBOARD_PROJECTHUD"),
    MAIN_DASHBOARD_REVIEW: t("common.commonEnum.MAIN_DASHBOARD_REVIEW"),
    MAIN_DASHBOARD_APPROVE: t("common.commonEnum.MAIN_DASHBOARD_APPROVE"),
    MAIN_DASHBOARD_REJECT: t("common.commonEnum.MAIN_DASHBOARD_REJECT"),
    MAIN_DASHBOARD_VACATION: t("common.commonEnum.MAIN_DASHBOARD_VACATION"),
    MAIN_DASHBOARD_MARRIAGE: t("common.commonEnum.MAIN_DASHBOARD_MARRIAGE"),
    MAIN_DASHBOARD_PRIVILEGE: t("common.commonEnum.MAIN_DASHBOARD_PRIVILEGE"),
    MAIN_DASHBOARD_PRODUCT: t("common.commonEnum.MAIN_DASHBOARD_PRODUCT"),
    MAIN_DASHBOARD_COMPLETEGO: t("common.commonEnum.MAIN_DASHBOARD_COMPLETEGO"),
    MAIN_DASHBOARD_RUNNING: t("common.commonEnum.MAIN_DASHBOARD_RUNNING"),
    MAIN_DASHBOARD_DELIVERY: t("common.commonEnum.MAIN_DASHBOARD_DELIVERY"),
    MAIN_DASHBOARD_REDUCE: t("common.commonEnum.MAIN_DASHBOARD_REDUCE"),
    MAIN_DASHBOARD_IMPROVE: t("common.commonEnum.MAIN_DASHBOARD_IMPROVE"),
    MAIN_DASHBOARD_APPROVED: t("common.commonEnum.MAIN_DASHBOARD_APPROVED"),
    MAIN_DASHBOARD_ACCEPTED: t("common.commonEnum.MAIN_DASHBOARD_ACCEPTED"),
    MAIN_DASHBOARD_TENTATIVE: t("common.commonEnum.MAIN_DASHBOARD_TENTATIVE"),
    MAIN_DASHBOARD_MAYBE: t("common.commonEnum.MAIN_DASHBOARD_MAYBE"),
    MAIN_DASHBOARD_PENDING_EVENTS: t(
      "common.commonEnum.MAIN_DASHBOARD_PENDING_EVENTS",
    ),
    MAIN_DASHBOARD_UPCOMING_EVENTS: t(
      "common.commonEnum.MAIN_DASHBOARD_UPCOMING_EVENTS",
    ),
    PLEASE_SELECT_SESSION_BEFORE_ENTER_QUESTION: t(
      "common.commonEnum.PLEASE_SELECT_SESSION_BEFORE_ENTER_QUESTION",
    ),
  };
};

export const BUTTON_TEXT = () => {
  const { t } = useTranslation();
  return {
    YES: t("common.buttonText.yes"),
    NO: t("common.buttonText.no"),
    CANCEL: t("common.buttonText.cancel"),
    UPDATE: t("common.buttonText.update"),
    CREATE: t("common.buttonText.create"),
    INVITE: t("common.buttonText.invite"),
    SAVE: t("common.buttonText.save"),
    OK: t("common.buttonText.ok"),
    CHANGE: t("common.buttonText.change"),
    DELETE: t("common.buttonText.delete"),
    UPGRADE: t("common.buttonText.upgrade"),
    BACK: t("common.buttonText.back"),
    SEND: t("common.buttonText.send"),
    PROCEED: t("common.buttonText.proceed"),
    YES_PROCEED: t("common.buttonText.yesProceed"),
    ARCHIVE: t("common.buttonText.archive"),
    EDIT: t("common.buttonText.edit"),
    RETRIEVE: t("common.buttonText.retrieve"),
    APPROVE: t("common.buttonText.approve"),
    APPROVED: t("common.buttonText.approved"),
    SUBMIT: t("common.buttonText.submit"),
    CONFIRM: t("common.buttonText.confirm"),
    REJECT: t("common.buttonText.reject"),
    REJECTED: t("common.buttonText.rejected"),
    REVISE: t("common.buttonText.revise"),
    ADD: t("common.buttonText.add"),
    VIEW: t("common.buttonText.view"),
    VIEW_LESS: t("common.buttonText.viewLess"),
    READ_MORE: t("common.buttonText.readMore"),
    VIEW_LESS_ACTION_ITEMS: t("common.buttonText.viewLessActionItems"),
    VIEW_ALL_ACTION_ITEMS: t("common.buttonText.viewAllActionItems"),
    UPLOAD_FILE: t("common.buttonText.uploadFile"),
    ACTIVATE: t("common.buttonText.activate"),
    DEACTIVATE: t("common.buttonText.deactivate"),
    LIGHT_MODE: t("common.buttonText.lightMode"),
    DARK_MODE: t("common.buttonText.darkMode"),
    DEFAULT_MODE: t("common.buttonText.defaultMode"),
  };
};

export const SUBSCRIPTION_CONSTANTS_TR = () => {
  const { t } = useTranslation();
  return {
    SUBSCRIPTION_TITLE_TEXT: t("common.subscribe.SUBSCRIPTION_TITLE_TEXT"),
    SUBSCRIPTION_CAPTION_TEXT: t("common.subscribe.SUBSCRIPTION_CAPTION_TEXT"),
  };
};

export const TAGS_COLOR = [
  { backgroundColor: "#eaf2ff", borderColor: "#4086ff" },
  { backgroundColor: "#e9f7ee", borderColor: "#2ecc71" },
  { backgroundColor: "#f0eeff", borderColor: "#7f70f7" },
  { backgroundColor: "#ffece5", borderColor: "#f56c40" },
  { backgroundColor: "#e1e6ec", borderColor: "#3c5269" },
  { backgroundColor: "#ffe9fa", borderColor: "#db4aa6" },
  { backgroundColor: "#e5faff", borderColor: "#00b7c2" },
];
